// @flow

import type {Locale} from 'docs/data';
import type {LocaleRequestModel} from 'docs/types';

export const transformLocale = (model: LocaleRequestModel): Locale => ({
  code: model.code,
  name: model.name,
  generated: model.generated,
});
